import React from 'react';
import Loading from '@catalogo/ui-americanas-mobile-loading';
import { TermNotFound, Question } from '../../molecules';
import { WrapperLoading } from './styled';
import { IQuestionsList, IQuestion } from '../../../types';

export const Questions = ({
  productId,
  questions,
  loading,
  totalQuestions,
  totalTermFound,
  term,
  product,
  config,
  dispatchMetrics,
  isDesk,
}: IQuestionsList) => {
  if (loading) {
    return (
      <WrapperLoading>
        <Loading />
      </WrapperLoading>
    );
  }

  if (totalTermFound === 0 && term && totalQuestions) {
    return (
      <TermNotFound
        productId={productId}
        config={config}
        product={product}
        dispatchMetrics={dispatchMetrics}
        isDesk={isDesk}
      />
    );
  }

  return (
    <>
      {questions.map((question: IQuestion, index: number) => (
        <Question
          isDesk={isDesk}
          key={question.id}
          question={question}
          term={term}
          totalTermFound={totalTermFound}
          isLast={questions.length - 1 === index}
        />
      ))}
    </>
  );
};

export default Questions;
